export enum GalleryType {
  Slider = 'slider',
  Tiles = 'tiles',
}
